import { render, staticRenderFns } from "./addReturnAddress.vue?vue&type=template&id=483e66f6&scoped=true"
import script from "./addReturnAddress.vue?vue&type=script&lang=js"
export * from "./addReturnAddress.vue?vue&type=script&lang=js"
import style0 from "./addReturnAddress.vue?vue&type=style&index=0&id=483e66f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483e66f6",
  null
  
)

export default component.exports